export enum UserMemberships {
  basic = 33,
  pro = 34,
  best = 35,
}

export const membershipImageBasePath = 'images/membership_logos/';
